// The Private-vs-Unlisted copy, in one place so the two halves cannot drift
// (Cowork009 §5).
//
// This advice appears twice, in opposite directions:
//   `notice`  BEFORE the mistake — on the landing page and the create screen
//   `error`   AFTER the mistake — the spec §7 response to a Private URL
//
// A creator who reads the notice, gets it wrong anyway, and then meets
// differently-worded advice has to work out whether they are looking at two
// different problems. They are not. Both strings are built from the same core
// sentence below, so editing one edits both.
//
// COWORK023 §2 — THE NOTICE NO LONGER SAYS "UNLISTED, NOT PRIVATE".
//
// It used to open "Set the video to Unlisted, not Private", which turns the one
// hard constraint we actually have into a requirement we do not. PUBLIC VIDEOS
// EMBED PERFECTLY WELL. Only Private is impossible, and only because YouTube
// refuses to embed it for anyone. Saying "unlisted" reads as a blocker to anyone
// who wants to run this on a video they have already published.
//
// So the notice now leads with what WORKS and only then names what does not.
//
// THE ERROR IS DELIBERATELY UNCHANGED, to the byte. It fires only when a video
// really is Private, and at that moment every word of it is still true and still
// the most useful thing to say. Cowork023 acceptance 5 asserts this.
//
// The only runtime value in shared/ — everything else here is types. It has no
// imports, so the NodeNext server build and the bundler client build both
// resolve it without extension games.
const CORE = "Private videos can't be embedded — not by us, not by anyone";

// Lowercase, because it now appears mid-sentence in the notice. The error
// capitalises it rather than holding a second copy — the point of this file is
// that there is exactly one of each sentence.
const FIX = 'change it to Unlisted in YouTube Studio';
const capitalised = FIX.charAt(0).toUpperCase() + FIX.slice(1);

export const privateVideoGuidance = {
  notice:
    `Public or unlisted both work. ${CORE} — so reviewers would just see a ` +
    `dead player. If yours is Private, ${FIX}; Unlisted still keeps it out of search.`,

  error: `That video is set to Private. ${CORE}. ${capitalised} and try again.`
};
